export const isPastDate = (dateStr: string): boolean => {
  const sanitized = dateStr.trim();

  const normalized = sanitized.replace(/\//g, '-');

  const parsedDate = new Date(normalized);

  if (isNaN(parsedDate.getTime())) {
    return false;
  }
  const now = new Date();
  now.setHours(0, 0, 0, 0);

  return parsedDate < now;
};

export const formatDateString = (dateStr: string, format: string): string => {
  const cleanedInput = dateStr.replace(/(\d+)(st|nd|rd|th)/gi, '$1');

  const date = new Date(cleanedInput);
  if (isNaN(date.getTime())) {
    throw new Error(`Invalid date string: "${dateStr}"`);
  }

  const pad = (n: number, width = 2) => n.toString().padStart(width, '0');

  const getOrdinal = (n: number) => {
    if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  const monthNamesFull = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const monthNamesShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const weekdayNamesShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const yearFull = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours24 = date.getHours();
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours24 >= 12 ? 'PM' : 'AM';

  const replacements: { [key: string]: string } = {
    YYYY: yearFull.toString(),
    YY: yearFull.toString().slice(-2),
    MM: pad(month),
    DD: pad(day),
    MMMM: monthNamesFull[date.getMonth()],
    MMM: monthNamesShort[date.getMonth()],
    Do: getOrdinal(day),
    D: day.toString(),
    HH: pad(hours24),
    hh: pad(hours12),
    mm: pad(minutes),
    ss: pad(seconds),
    A: ampm,
    a: ampm.toLowerCase(),
    ddd: weekdayNamesShort[date.getDay()],
  };

  return format.replace(
    /YYYY|YY|MMMM|MMM|Do|DD|D|MM|HH|hh|mm|ss|A|a|ddd/g,
    (match) => replacements[match] ?? match,
  );
};
